import React from 'react';
import { Checkbox } from '@lt/components';
import styled, { css } from 'styled-components';
import { useTranslation } from '@lt/localization';
import type { TouristNameProps } from './types';
import TouristNameField from './TouristNameField';

type TouristPatronymicFieldProps = {
  isMobile: boolean;
  hidePatronymic: boolean;
  handleHidePatronymic: (patronymic: boolean) => void;
} & TouristNameProps;

const TouristPatronymicField = (props: TouristPatronymicFieldProps) => {
  const { hidePatronymic, handleHidePatronymic, isMobile, ...other } = props;

  const handleClick = () => {
    handleHidePatronymic(!hidePatronymic);
  };

  const { t } = useTranslation();

  return (
    <PatronymicContainer isMobile={isMobile}>
      <TouristNameField disabled={hidePatronymic} {...other} />
      <Checkbox
        onClick={handleClick}
        checked={hidePatronymic}
        isMobile={isMobile}
      >
        {t('checkout.touristForm.patronymic.noPatronymic')}
      </Checkbox>
    </PatronymicContainer>
  );
};

const PatronymicContainer = styled.div<{ isMobile: boolean }>`
  ${(props) =>
    props.isMobile
      ? css`
          display: flex;
          flex-direction: column;
          flex-grow: 1;
          max-width: none;
          flex-basis: 100%;
          margin-bottom: 7px;
          min-width: 40px;
        `
      : css`
          > * + * {
            margin-top: 6px;
            gap: 8px;
          }
        `}
`;

export default TouristPatronymicField;
